/********************************************
 * Members
 *
 ********************************************/
function fnTeamCarousel( i, oSection ) {

	/*****************
	 * Objects
	 *****************/
	var oSection				= $( oSection ),
		oCarousel				= $( '.carousel', oSection ),
		oArrows					= $( 'nav.arrows', oSection ),
		iCurrentSlide;


	/*****************
	 * Carousel configuration
	 *****************/

	/**
	 * Initialise Flickity
	 */
	var $oFlickity				= oCarousel.flickity({
		cellAlign: 					'left',
		wrapAround: 				false,
		freeScroll: 				true,
		freeScrollFriction: 		0.075,
		contain: 					true,
		accessibility: 				false,
		prevNextButtons: 			false,
		pageDots: 					false
	});

	/**
	 * Store carousel data
	 */
	var aCarouselData			= $oFlickity.data( 'flickity' );

	/**
	 * Arrow buttons (prev/next)
	 */
	oArrows.find( 'i.next' ).on( 'click', function() {
		$oFlickity.flickity( 'next' );
	});
	oArrows.find( 'i.prev' ).on( 'click', function() {
		$oFlickity.flickity( 'previous' );
	});

}


// END OF DOCUMENT
